import { Grid, TextField } from '@mui/material';
import BarcodeScanner from 'components/BarcodeScanner';
import { useLanguage } from 'context/AppContext';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

type Props = {
  onDetected: (code: string) => void;
};

export const BarcodeScannerInput: FC<Props> = ({ onDetected }) => {
  const lang = useLanguage()[0].BarcodeScanner;

  const barcodeInputRef = useRef<HTMLInputElement>(null);
  const [barcode, setBarcode] = useState<string>('');

  const focusBarcodeInput = useCallback(() => {
    setTimeout(() => {
      barcodeInputRef.current?.focus();
    }, 100);
  }, []);

  // focus the barcode input on load
  useEffect(focusBarcodeInput, [focusBarcodeInput]);

  useEffect(() => {
    if (barcode) {
      onDetected(barcode);
    }
  }, [barcode, onDetected]);

  return (
    <Grid container gap={2} direction="column" alignItems="center">
      <BarcodeScanner onDetected={setBarcode} />

      <TextField
        inputRef={barcodeInputRef}
        label={lang.barcode}
        placeholder={lang.scanOrEnterBarcode}
        value={barcode}
        onChange={event => setBarcode?.(event.target.value)}
        onBlur={focusBarcodeInput}
        sx={{ width: '100%' }}
      />
    </Grid>
  );
};
